import axios from 'axios';

import { environment } from '../../environment';

export const HttpDefaults = () => {
    axios.defaults.baseURL = environment.apiUrl;
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.patch['Content-Type'] = 'application/json';
};

export const HttpDefaultHeaders = (key, value) => {
    axios.defaults.headers.common[key] = value;
};



// WEBPACK FOOTER //
// ./src/components/http/Defaults.js